import { useState, useEffect, useCallback } from "react";
import {
    useLoginWithMagicToken,
    UnAuthorizedErrorMessage,
    clearTokenCookies
} from "../../../lib/auth/authService";

export const useSupplierAuthentication = (token: string) => {
    const [isAuthenticated, setIsAuthenticated] = useState<
        boolean | undefined
    >();

    // External navigation
    const navigateToExternalHomePage = useCallback(() => {
        window.location.href = "https://www.pflegehilfe.org/mitglied-werden";
    }, []);

    // Login with magic token
    const { mutate: loginWithMagicToken } = useLoginWithMagicToken({
        onSuccess: (data) => {
            setIsAuthenticated(data !== UnAuthorizedErrorMessage);
        },
        onError: () => {
            navigateToExternalHomePage();
        }
    });

    useEffect(() => {
        loginWithMagicToken(token);
    }, [loginWithMagicToken, token]);

    return { isAuthenticated, navigateToExternalHomePage };
};
